import axios from "axios";
import {
  post,
  del,
  get,
  put,
  postWithFormData,
  putWithFormData,
} from "./api_helper";
import * as url from "./url_helper";

// Create Class
export const fetchAllTemplate = async () => {
  const token = localStorage.getItem("token");
  const urls = await url.getUrls();
  const endpoint = urls.GET_ALL_TEMPLATE;
  // return await get(endpoint, {
  //   headers: {
  //     Authorization: `Bearer ${token}`,
  //   },
  // });

  return await get(endpoint);
};
// export const createTemplate = async (templateName, image) => {
//   const token = localStorage.getItem("token");
//   const urls = await url.getUrls();
//   const endpoint = `${urls.CREATE_TEMPLATE}?TempName=${templateName}`;

//   const formData = new FormData();
//   formData.append("ImgTemp", image);

//   return await post(endpoint, formData, {
//     headers: {
//       Authorization: `Bearer ${token}`,
//     },
//   });
// };

export const createTemplate = async (templateName, image) => {
  const urls = await url.getUrls();

  const endpoint = `${urls.CREATE_TEMPLATE}?TempName=${encodeURIComponent(
    templateName
  )}`;

  const formData = new FormData();
  formData.append("ImgTemp", image);

  return await postWithFormData(endpoint, formData);
};

export const getLayoutDataById = async (id) => {
  const urls = await url.getUrls();

  const endpoint = `${urls.GET_LAYOUT_DATA}?id=${encodeURIComponent(id)}`;

  return await get(endpoint);
};

// export const updateTemplate = async (FileName, image) => {
//   const urls = await url.getUrls();
//   const endpoint = `${urls.UPDATE_TEMPLATE}?FileName=${FileName}`;
//   const token = localStorage.getItem("token");
//   const formData = new FormData();
//   formData.append("tempName", image);

//   const config = {
//     headers: {
//       "Content-Type": "multipart/form-data",
//       Authorization: `Bearer ${token}`,
//     },
//   };

//   return await putWithFormData(endpoint, formData, config);
// };

export const updateTemplate = async (fileName, jsonFile) => {
  const urls = await url.getUrls();

  const endpoint = `${urls.UPDATE_TEMPLATE}?FileName=${encodeURIComponent(
    fileName
  )}`;

  const formData = new FormData();

  // 🔴 THIS MUST MATCH BACKEND EXACTLY
  formData.append("tempName", jsonFile);

  return await putWithFormData(endpoint, formData);
};

export const deleteTemplate = async (id) => {
  const urls = await url.getUrls();

  const endpoint = `${urls.DELETE_TEMPLATE}?id=${encodeURIComponent(id)}`;

  return await del(endpoint);
};

// export const deleteTemplate = async (id) => {
//   const urls = await url.getUrls();
//   const endpoint = `${urls.DELETE_TEMPLATE}?id=${id}`;
//   const token = localStorage.getItem("token");

//   return await del(endpoint, {
//     headers: {
//       Authorization: `Bearer ${token}`,
//     },
//   });
// };

// export const getLayoutDataById = async (id) => {
//   const token = localStorage.getItem("token") ?? "";
//   const urls = await url.getUrls();
//   const endpoint = `${urls.GET_LAYOUT_DATA}?id=${id}`;
//   return await get(endpoint, {
//     headers: {
//       Authorization: `Bearer ${token}`,
//     },
//   });
// };

export const sendFile = async (data) => {
  const urls = await url.getUrls();
  const endpoint = urls.SEND_FILE;
  return await postWithFormData(endpoint, data);
};

export const getSampleData = async () => {
  const urls = await url.getUrls();
  const endpoint = urls.GET_SCANNED_IMAGE;
  return await get(endpoint);
};

export const getTemplateImage = async (path) => {
  const urls = await url.getUrls();
  const endpoint = `${urls.GET_TEMPLATE_IMAGE}?filePath=${path}`;
  return await get(endpoint);
};

export const getTemplateCsv = async (path) => {
  const urls = await url.getUrls();
  const endpoint = `${urls.GET_TEMPLATE_CSV}?csvPath=${path}`;
  return await get(endpoint);
};

export const cancelScan = async () => {
  const urls = await url.getUrls();
  const endpoint = urls.CANCEL_SCAN;
  return await get(endpoint);
};

export const checkJobStatus = async (id) => {
  const urls = await url.getUrls();
  const endpoint = `${urls.CHECK_DELETE_TEMPLATE}?Id=${id}`;
  return await get(endpoint);
};

export const getBaseURL = async (id) => {
  const urls = await url.getUrls();
  const endpoint = `${urls.MAIN_URL}`;
  return await get(endpoint);
};
